'use client';

import { Button } from '@/components/ui/button'; 
import { useState, useEffect, useRef } from 'react';
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';

interface TypeSing_lab_Carousel {
    basic: string[];
    colorBtn: string;
}

export default function Accordions_sing_lab(props: TypeSing_lab_Carousel) {
    const [isOpen, setIsOpen] = useState(false);
    const [showButton, setShowButton] = useState(false);
    const contentRef = useRef<HTMLDivElement>(null);

    const { basic } = props;

    useEffect(() => {
        const observer = new ResizeObserver(() => {
            if (contentRef.current) {
                setShowButton(contentRef.current.scrollHeight > 50);
            }
        });

        if (contentRef.current) {
            observer.observe(contentRef.current);
        }

        return () => {
            if (contentRef.current) {
                observer.unobserve(contentRef.current);
            }
        };
    }, [basic]);

    const colors = ['bg-blue', 'bg-[#1b7332]', 'bg-[#c5822d]'];

    return (
        basic &&
        basic.length > 0 && (
            <div 
                className={`
                duration-300 flex flex-col gap-4
                transition-max-height ease-in-out
                ${
                    isOpen
                        ? 'max-h-screen'
                        : 'max-h-[60px] lg:max-h-[70px] brightness-bottom'
                }
                w-full py-2 rounded-md bg-white relative overflow-hidden
                ${showButton ? 'pb-10' : ''}
            `}
                id="section-3"
            >
                <div
                    ref={contentRef}
                    className="flex flex-wrap justify-center gap-2"
                >
                    {basic.map((item, index) => (
                        <div
                            key={index}
                            className={`text-center ${
                                colors[index % colors.length]
                            } bg-blue text-white text-sm px-2.5 py-1 rounded-xl`}
                        >
                            {item}
                        </div>
                    ))}
                </div>

                {showButton && (
                    <Button
                        onClick={() => setIsOpen(!isOpen)}
                        variant={'link'}
                        className={`
                        text-center w-full left-0 absolute -bottom-1 rounded-none
                        bg-opacity-10 bg-white/80 h-9
                        text-sm sm:text-base md:text-base
                    `}
                        aria-expanded={isOpen}
                        style={{
                            zIndex: 10,
                        }}
                    >
                        {isOpen ? (
                            <IoIosArrowUp className="text-2xl text-black" />
                        ) : (
                            <IoIosArrowDown className="text-2xl text-black" />
                        )}
                    </Button>
                )}
            </div>
        )
    );
}
